import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserManageCompanies {
  constructor($scope, UserService, PaginationService) {
    $scope.tabs = [
      {
        title: 'All',
        user_type: null,
        users: [],
        page: 1
      },
      {
        title: 'Buyers',
        user_type: 'Buyer',
        users: [],
        page: 1
      },
      {
        title: 'Sellers',
        user_type: 'Seller',
        users: [],
        page: 1
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
      $scope.query = '';
    };

    $scope.quick_search = function() {
      window.filter_table('table#users', $scope.query);
    };

    $scope.common_filters = function() {
      return {
        per_page: 50
      };
    };

    $scope.load_users = function(tab) {
      $scope.query = '';
      var filters = $scope.common_filters();
      filters.page = tab.page;
      filters.user_type = tab.user_type;
      UserService.search(filters).then(function(data) {
        tab.users = data.users;
        tab.pagination = PaginationService.get_pagination(data.pagination);
      });
    };

    $scope.load_pending_imports = function() {
      $scope.pending_imports = [];
      UserService.get_pending_imports().then(function(data) {
        $scope.pending_imports = data.pending_imports;
      });
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.view_pending_import = function(pending_import) {
      $scope.dialog = pending_import;
      $scope.open_dialog('pending_import_dialog');
    };

    $scope.delete_pending_import = function() {
      if (confirm('Are you sure you want to delete this pending import?')) {
        $scope.deleting = true;
        UserService.delete_pending_import($scope.dialog.id).then(function(data) {
          if (data.success) {
            var index = $scope.pending_imports.indexOf($scope.dialog);
            $scope.pending_imports.splice(index, 1);
            $scope.deleting = false;
            $.fancybox.close();
          }
        });
      }
    };

    $scope.check_pending_imports = function() {
      _.each($scope.pending_imports, function(i) {
        i.checked = $scope.pending_imports_checked;
      });
    };

    $scope.mass_create_users = function() {
      var imports = _.where($scope.pending_imports, {
        checked: true
      });
      if (imports.length === 0) {
        alert('Please select at least one Pending Import!');
      } else {
        $scope.mass_creating_users = true;
        UserService.mass_create_from_pending_imports(_.pluck(imports, 'id')).success(function(data) {
          if (data.success) {
            $scope.mass_creating_users = false;
            $scope.load_pending_imports();
          }
        });
      }
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.pending_imports = [];
      angular.forEach($scope.tabs, function(tab) {
        $scope.load_users(tab);
      });
      $scope.load_pending_imports();
    };

    $scope.init();
  }
}

UserManageCompanies.$inject = ['$scope', 'UserService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-manage-companies.ctrl.js